export const TAB_CLASS_NAME = 'kurama-tab'
